<script setup lang="ts">
import { computed } from 'vue';
import Textarea from 'primevue/textarea';
import { InputGroup, Typography } from '@apparatix/library/core';
import DetailEditorBaseSingle from './DetailEditorBaseSingle.vue';
import type { ContactNotesErrors } from '@apparatix/schemas/ContactNote';

type Props = {
  noHeadingLabels?: boolean;
  errors: ContactNotesErrors;
}

const props = defineProps<Props>();

const colLabel = computed(() => {
  if (props.noHeadingLabels) return undefined;
  return 'Contact Notes';
});

const contactNotes = defineModel<object>('contactNotes');

const setNote = (newValue: string) => {
  if (! contactNotes.value[0]) {
    contactNotes.value[0] = { note: newValue };
    return;
  }
  contactNotes.value[0].note = newValue;
};

const note = computed({
  get: () => contactNotes.value[0]?.note || '',
  set: (newValue: string) => setNote(newValue),
});

</script>
<template>
  <DetailEditorBaseSingle :col-header="colLabel">
    <template #col>
      <InputGroup>
        <Textarea
          v-model="note"
          auto-resize
          variant="filled"
          fluid
        />
        <Typography v-if="Boolean(props.errors?.notes)" variant="form-error">
          {{ props.errors.notes }}
        </Typography>
      </InputGroup>
    </template>
  </DetailEditorBaseSingle>
</template>
